<template>
<!-- style="height: 600px" -->
  <div class="main_area" >
    <div id="redPacket" v-if="hongbashow && $store.state.appInfo.redpacket_switch == 1">
      <i class="grab" @click="$parent.goNav('/hongbao')"></i>
      <img @click="changhongbashow" src="/static/image/close_popup.png" />
    </div>
    <div class="layout mainpage fullpage_white" style="padding: 0px">
      <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
        <van-swipe-item v-for="(item, index) in bannerList" :key="index">
          <img :src="item.src" alt="" style="width: 100%" />
        </van-swipe-item>
      </van-swipe>
      <div class="index_sticky_area">
        <div class="announcement_div">
          <a class="index_announcement_area" @click="$parent.goNav('/message?type=1')">
            <div class="title"><img alt="" class="marquee_title_img" src="/static/image/marquee.png" /></div>
            <marquee class="marquee_item" scrollamount="4"
              ><div v-for="(item, index) in homenoticelis" :key="index">
                {{ item }}
              </div>
            </marquee>
            <!-- <div class="midbtn_url"><img class="marquee_url_icon" alt="" src="/static/image/url.png" /><span>9500.com</span></div> -->
          </a>
        </div>
        <!-- 登录 未 登录 -->
        <div class="index_sub_profile_left">
          <div class="index_sub_profile_right">
            <div class="index_sub_profile">
              <div class="left" v-if="!$store.state.token">
                <div class="before_login active">
                  <div><a @click="$parent.goNav('/login?type=0')"></a><a @click="$parent.goNav('/login?type=1')"></a> <span class="login_text">登录 </span><span class="slash_text">/</span><span class="register_text"> 注册</span></div>
                </div>
              </div>
              <div class="left" v-if="$store.state.token">
                <a href="javascript:;">
                  <div class="after_login active">
                    <div>
                      <div class="username">{{ $store.state.userInfo.username || '' }}</div>
                    </div>
                    <div>
                      <span>¥ {{ $store.state.userInfo.balance }}</span>
                    </div>
                  </div>
                </a>
              </div>
              <div class="right">
                <div class="item">
                  <a @click="$parent.goNav('/wallet?type=0')">
                    <div><img src="/static/image/midbtn_deposit.png" /> 存款</div>
                  </a>
                  <a @click="$parent.goNav('/withdraw')">
                    <div><img src="/static/image/midbtn_withdrawal.png" /> 取款</div>
                  </a>
                  <a @click="$parent.goNav('/transfer')"
                    ><div><img src="/static/image/midbtn_transfer.png" /> 转账</div></a
                  >
                  <a @click="$parent.goNav('/vip')"
                    ><div><img src="/static/image/nav_vip.png" /> VIP</div></a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="homepage_bottom">
          <div class="index_game_area active">
            <div class="game_menu" style="height: 400px">
              <!-- 真人 -->
              <div class="game_menu_item live active" data-cat="live">
                <div><img src="/static/image/gameCategoryImage1634600037.png" data-active="/static/image/gameCategoryImage1634600037.png" data-disable="/static/image/gameCategoryImage2_1634600037.png" />真人</div>
              </div>
              <!-- 电子 -->
              <div class="game_menu_item slots" data-cat="slots">
                <div><img src="/static/image/gameCategoryImage2_1634599917.png" data-active="/static/image/gameCategoryImage1634599917.png" data-disable="/static/image/gameCategoryImage2_1634599917.png" />电子</div>
              </div>
              <!-- 体育 -->
              <div class="game_menu_item sports" data-cat="sports">
                <div><img src="/static/image/gameCategoryImage2_1634600080.png" data-active="/static/image/gameCategoryImage1634600080.png" data-disable="/static/image/gameCategoryImage2_1634600080.png" />体育</div>
              </div>
              <!-- 电竞 -->
              <div class="game_menu_item esports" data-cat="esports">
                <div><img src="/static/image/gameCategoryImage2_1634600045.png" data-active="/static/image/gameCategoryImage1634600045.png" data-disable="/static/image/gameCategoryImage2_1634600045.png" />电竞</div>
              </div>
              <!-- 彩票 -->
              <div class="game_menu_item lottery" data-cat="lottery">
                <div><img src="/static/image/gameCategoryImage2_1634600056.png" data-active="/static/image/gameCategoryImage1634600056.png" data-disable="/static/image/gameCategoryImage2_1634600056.png" />彩票</div>
              </div>
              <!-- 棋牌 -->

              <div class="game_menu_item poker" data-cat="poker">
                <div><img src="/static/image/gameCategoryImage2_1634600026.png" data-active="/static/image/gameCategoryImage1634600026.png" data-disable="/static/image/gameCategoryImage2_1634600026.png" />棋牌</div>
              </div>
            </div>
            <div class="game_list" style="height: 400px">
              <!-- 真人  OG ob -->
              <div class="game_list_item live active" data-cat="live" data-varcount="7" style="height: 400px">
                <div>
                  <div class="game_item" v-for="(item, index) in realbetList" :key="index" v-if="item.app_state == 1">
                    <a href="javascript:;" class="h5OpenGame fallback" @click="$parent.openGamePage(item.platform_name, item.game_code, '')"> <img class="vgc_img" alt="" :src="`/static/image/realbet/${item.platform_name}.jpg`" /> </a>
                    <div class="game_type" style="width: 109.153px; height: 33.5855px; padding-top: 11.1952px; padding-bottom: 8px"><img alt="" :src="`/static/image/realbet/${item.platform_name}.jpg`" />{{ item.name }}</div>
                  </div>
                </div>
              </div>
              <!-- 电子 -->
              <div class="game_list_item slots" data-cat="slots" data-varcount="7" style="height: 400px">
                <div>
                  <div class="game_item">
                    <a href="javascript:;" class="h5OpenGame fallback" @click="$parent.goNav('/electronics?type=obgdy')"> <img class="vgc_img" alt="" src="/static/image/concise/obgpy.png" /> </a>
                    <div class="game_type" style="width: 109.153px; height: 33.5855px; padding-top: 11.1952px; padding-bottom: 8px"><img alt="" src="/static/image/concise/obgpy.png" />OB电子</div>
                  </div>
                  <div class="game_item">
                    <a href="javascript:;" class="h5OpenGame fallback" @click="$parent.goNav('/electronics?type=fgdz')"> <img class="vgc_img" alt="" src="/static/image/concise/fgdz.png" /> </a>
                    <div class="game_type" style="width: 109.153px; height: 33.5855px; padding-top: 11.1952px; padding-bottom: 8px"><img alt="" src="/static/image/concise/fgdz.png" />FG电子</div>
                  </div>
                  <div class="game_item">
                    <a href="javascript:;" class="h5OpenGame fallback" @click="$parent.goNav('/electronics?type=pp')"> <img class="vgc_img" alt="" src="/static/image/concise/ppdz.png" /> </a>
                    <div class="game_type" style="width: 109.153px; height: 33.5855px; padding-top: 11.1952px; padding-bottom: 8px"><img alt="" src="/static/image/concise/ppdz.png" />PP电子</div>
                  </div>
                  <div class="game_item">
                    <a href="javascript:;" class="h5OpenGame fallback" @click="$parent.goNav('/electronics?type=ae')"> <img class="vgc_img" alt="" src="/static/image/concise/aedz.png" /> </a>
                    <div class="game_type" style="width: 109.153px; height: 33.5855px; padding-top: 11.1952px; padding-bottom: 8px"><img alt="" src="/static/image/concise/aedz.png" />AE电子</div>
                  </div>
                        <div class="game_item">
                    <a href="javascript:;" class="h5OpenGame fallback" @click="$parent.goNav('/electronics?type=fgfish')"> <img class="vgc_img" alt="" src="/static/image/concise/fgfish.png" /> </a>
                    <div class="game_type" style="width: 109.153px; height: 33.5855px; padding-top: 11.1952px; padding-bottom: 8px"><img alt="" src="/static/image/concise/fgfish.png" />FG捕鱼</div>
                  </div>
                        <div class="game_item">
                    <a href="javascript:;" class="h5OpenGame fallback" @click="$parent.goNav('/electronics?type=pg')"> <img class="vgc_img" alt="" src="/static/image/concise/pg.png" /> </a>
                    <div class="game_type" style="width: 109.153px; height: 33.5855px; padding-top: 11.1952px; padding-bottom: 8px"><img alt="" src="/static/image/concise/pg.png" />PG电子</div>
                  </div>
                  <div class="game_item" v-for="(item, index) in conciseList" :key="index" v-if="item.app_state == 1 && item.platform_name != 'pg'">
                    <a href="javascript:;" class="h5OpenGame fallback" @click="$parent.openGamePage(item.platform_name, item.game_code, '')"> <img class="vgc_img" alt="" :src="`/static/image/concise/${item.platform_name}.png`" /> </a>
                    <div class="game_type" style="width: 109.153px; height: 33.5855px; padding-top: 11.1952px; padding-bottom: 8px"><img alt="" :src="`/static/image/concise/${item.platform_name}.png`" />{{ item.name }}</div>
                  </div>
                </div>
              </div>
              <!-- 体育 -->
              <div class="game_list_item sports" data-cat="sports" data-varcount="6" style="height: 400px">
                <div>
                  <div class="game_item" v-for="(item, index) in sportList" :key="index" v-if="item.app_state == 1">
                    <a href="javascript:;" class="h5OpenGame fallback" @click="$parent.openGamePage(item.platform_name, item.game_code, '')"> <img class="vgc_img" alt="" :src="`/static/image/sport/${item.platform_name}.jpg`" /> </a>
                    <div class="game_type" style="width: 109.153px; height: 33.5855px; padding-top: 11.1952px; padding-bottom: 8px"><img alt="" :src="`/static/image/sport/${item.platform_name}.jpg`" />{{ item.name }}</div>
                  </div>
                </div>
              </div>

              <!-- 电竞 雷火 泛亚 ob-->
              <!--  -->
              <div class="game_list_item esports" data-cat="esports" data-varcount="6" style="height: 400px">
                <div>
                  <div class="game_item" v-for="(item, index) in gamingList" :key="index" v-if="item.app_state == 1">
                    <a href="javascript:;" class="h5OpenGame fallback" @click="$parent.openGamePage(item.platform_name, item.game_code, '')"> <img class="vgc_img" alt="" :src="`/static/image/gaming/${item.platform_name}.jpg`" /> </a>
                    <div class="game_type" style="width: 109.153px; height: 33.5855px; padding-top: 11.1952px; padding-bottom: 8px"><img alt="" :src="`/static/image/gaming/${item.platform_name}.jpg`" />{{ item.name }}</div>
                  </div>
                </div>
              </div>
              <!-- 彩票 -->
              <div class="game_list_item lottery" data-cat="lottery" data-varcount="6" style="height: 400px">
                <div>
                  <div class="game_item" v-for="(item, index) in lotteryList" :key="index" v-if="item.app_state == 1">
                    <a href="javascript:;" class="h5OpenGame fallback" @click="$parent.openGamePage(item.platform_name, item.game_code, '')"> <img class="vgc_img" alt="" :src="`/static/image/lottery/${item.platform_name}.png`" /> </a>
                    <div class="game_type" style="width: 109.153px; height: 33.5855px; padding-top: 11.1952px; padding-bottom: 8px"><img alt="" :src="`/static/image/lottery/${item.platform_name}.png`" />{{ item.name }}</div>
                  </div>
                </div>
              </div>
              <!-- 棋牌 -->
              <div class="game_list_item poker" data-cat="poker" data-varcount="6" style="height: 400px">
                <div>
                  <div class="game_item" v-for="(item, index) in jokerList" :key="index" v-if="item.app_state == 1">
                    <a href="javascript:;" class="h5OpenGame fallback" @click="$parent.openGamePage(item.platform_name, item.game_code, '')"> <img class="vgc_img" alt="" :src="`/static/image/joker/${item.platform_name}.jpg`" /> </a>
                    <div class="game_type" style="width: 109.153px; height: 33.5855px; padding-top: 11.1952px; padding-bottom: 8px"><img alt="" :src="`/static/image/joker/${item.platform_name}.jpg`" />{{ item.name }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 首页弹窗 -->
    <div v-if="$store.state.appInfo.index_modal == 1" :class="gongGaoshwo ? 'modal fade normal_announcement show' : 'modal fade normal_announcement'" @click="changGo" id="normal_announcement_popout" aria-modal="true" style="display: block">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header border_radius_top">
            <div class="font-weight-bold text-left w-100" style="font-size: 17px">欢迎来到{{ $store.state.appInfo.title }}</div>
          </div>
          <div class="modal-body border_radius_bottom">
            <div v-html="$store.state.appInfo.webcontent"></div>
          </div>
        </div>
      </div>

      <!-- 原来的公告 -->
      <div class="modal-dialog" role="document" v-if="false">
        <div class="modal-content" @click="$parent.goNav('/message?type=1')">
          <div class="modal-header border_radius_top">
            <div class="font-weight-bold text-left w-50" style="font-size: 17px">公告</div>
            <div class="font-weight-bold text-right w-50"><a class="btn_more active" href="javascript:;"></a></div>
          </div>
          <div class="modal-body border_radius_bottom">
            <div>
              <div class="card_container mini index_notice_popup" v-for="(item, index) in homenoticelis" :key="index" style="position: unset" data-announcement_id="1000">
                <div class="collapse_a">
                  <div class="announcement_header">
                    <div class="announcement_title">公告</div>
                    <div class="announcement_date"></div>
                  </div>
                  <div class="announcement_content">
                    <div style="width: 100%">
                      <div class="announcement_message">{{ item }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 优惠悬浮 -->
    <div class="floating_img1">
      <div class="floating_img1_close" @click="closeYouhui"><img src="/static/image/close_popup.png" /></div>
      <div class="floating_image">
        <a href="javascript:;" @click="$parent.goNav('/discount')" target="_self"> <img src="/static/image/288-1.png" /> </a>
      </div>
    </div>
    <!-- app -->
    <div class="app_download_area" v-if="$store.state.appInfo.app_state == 1">
      <div class="cross" @click="close"><img class="" src="/static/image/close_reverse.png" /></div>
      <div><img class="app_icon" src="/static/image/app_icon.png" /></div>
      <div></div>
      <div>
        <a href="javascript:;" @click="$parent.goNav('/app')"><button class="btn appdl_browser_btn active">下载APP</button></a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'index',
  data() {
    return {
      homenoticelis: [],
      bannerList: [],
      gongGaoshwo: true,
      realbetList: [],
      jokerList: [],
      gamingList: [],
      sportList: [],
      lotteryList: [],
      conciseList: [],
      hongbashow: true,
    };
  },
  created() {
    let that = this;
    that.getGameList();

    that.getBanList(); //获取轮播
    that.homenotice(); //获取公告
  },
  methods: {
    close() {
      $('.app_download_area').hide();
    },
    changhongbashow() {
      this.hongbashow = false;
    },
    getGameList() {
      let that = this;
      that.$parent.showLoading();

      that.$apiFun.get('/api/game/list', { category: '' }).then(res => {
        if (res.code == 200) {
          let list = res.data;
          // that[name] = res.data;
          list.forEach(el => {
            if (el.category_id == 'realbet') {
              that.realbetList.push(el);
            }
            if (el.category_id == 'joker') {
              that.jokerList.push(el);
            }
            if (el.category_id == 'gaming') {
              that.gamingList.push(el);
            }
            if (el.category_id == 'sport') {
              that.sportList.push(el);
            }
            if (el.category_id == 'lottery') {
              that.lotteryList.push(el);
            }
            if (el.category_id == 'concise') {
              that.conciseList.push(el);
            }
          });
        }
        that.$parent.hideLoading();
      });
    },
    closeYouhui() {
      $('.floating_img1').hide();
    },
    changGo() {
      this.gongGaoshwo = false;
      $('#normal_announcement_popout').hide();
    },
    homenotice() {
      let that = this;
      that.$apiFun.post('/api/homenotice', {}).then(res => {
        console.log(res);
        if (res.code != 200) {
          that.$parent.showTost(0, res.message);
        }
        if (res.code == 200) {
          that.homenoticelis = res.data;
          // 没有记录 就显示
          that.gongGaoshwo = sessionStorage.getItem('gongGaoshwo') ? false : true;
          if (!that.gongGaoshwo) {
            $('#normal_announcement_popout').hide();
          }
        }
      });
    },
    getBanList() {
      let that = this;
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/bannerList', { type: 2 })
        .then(res => {
          console.log(res);
          if (res.code != 200) {
            that.$parent.showTost(res.message);
          }
          if (res.code == 200) {
            that.bannerList = res.data;
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
  },
  mounted() {
    let that = this;

    $('.game_menu_item').click(function () {
      $('.game_menu_item.active img').attr('src', $('.game_menu_item.active img').data('disable'));
      $('.game_menu_item').removeClass('active');
      $(this).addClass('active');
      $(this).find('img').attr('src', $(this).find('img').data('active'));

      $('.game_list_item').removeClass('active');
      $('.game_list_item.' + $(this).attr('data-cat')).addClass('active');
      $('.hotgame_area').removeClass('active');
      if ($(this).hasClass('slots')) {
        $('.hotgame_area').addClass('active');
      }
    });
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
@import '../../../static/css/announcement_modal.css';

.game_item {
  position: relative;
}

.game_item .box {
  position: absolute;
  top: 0;
  left: 0;
  height: 37px;
  width: 63px;
  background: #000;
}
</style>



// WEBPACK FOOTER //
// src/components/mode/index.vue